// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {theme} from "./theme";
import { ThemeProvider } from "styled-components";
import Home from "./pages/Home";
import About from "./pages/About";
import Partner from "./pages/Partner";
import ForSchool from "./pages/ForSchool";
import Join from "./pages/Join";
import Login from "./pages/Login";
import Feed from "./pages/Feed"
import './App.css';
import Network from "./pages/Network"
import Opportunities from "./pages/Opportunities";
import Academics from "./pages/Academics";
import Partners from "./pages/Partners";
import Chat from "./pages/Chat";
import UserHomepage from "./components/UserHomepage";
import { User } from "lucide-react";


function App() {
  return (
    <ThemeProvider theme={theme}>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schools" element={<ForSchool />} />
        <Route path="/login" element = {<Login />} />
        <Route path="/signup" element={<Join/>} />
        <Route path= "/home" element={<UserHomepage/>}/>
        <Route path="/feed" element={<Feed />} />
        <Route path = "network" element={<Network />} />
        <Route path="opportunities" element={<Opportunities/>} />
        <Route path="academics" element = {<Academics/>} />
        <Route path="partners" element = {<Partners/>} />
        <Route path="/about" element={<About />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/chat" element={<Chat/>}/>
      </Routes>
    </Router>
    </ThemeProvider>
  );
}

export default App;
